module.exports = __webpack_public_path__ + "static/media/home-services-1.70618c36.jpg";